var _defs, _path, _path2, _ellipse, _ellipse2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFailure = function SvgFailure(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fcc41e;\n      }\n\n      .cls-1,\n      .cls-2 {\n        stroke-linecap: round;\n      }\n\n      .cls-1,\n      .cls-2,\n      .cls-3 {\n        stroke: #010101;\n        stroke-linejoin: round;\n        stroke-width: 11px;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-4 {\n        fill: #010101;\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: #f18727;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m489.33,249.56c-.87-12.65-19.19-26.61-48.86-32s-55.55,17.32-55.55,17.32l-13.38-10c-35.09-63.59-67.26-67.62-137.47-69.81-58.6-1.83-71.47-35.67-103.34,13.79l-15.36,19.54s-26.17-12.71-55.84-7.32c-29.66,5.39-47.99,19.35-48.86,32-.87,12.65,14.83,8.75,23.56,12.88,8.35,3.95,34.87,8.13,50.99,32.93-18.61,33.61-29.44,69.6-30.34,98.41-2.4,77.06,72.91,117.91,176.25,121.14s198.21-33.61,200.61-110.67c.65-20.8-1.73-52.03-13.71-77.28,16.01-26.15,27.38-23.64,40.55-25.42,9.57-1.3,31.62-2.87,30.75-15.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m359.05,292.62c32.27-19.55,55.68-49.72,63.12-86.56,15.67-77.57-43.85-162.78-134.8-181.16C196.42,6.52,108.48,61.94,92.81,139.51c-9.44,46.73,8.95,93.53,44.95,127.38"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 200.98,
    cy: 105.06,
    rx: 19.23,
    ry: 9.78,
    transform: "translate(58.19 281.25) rotate(-78.58)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 331.26,
    cy: 130.94,
    rx: 19.23,
    ry: 9.78,
    transform: "translate(137.3 429.71) rotate(-78.58)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m156.79,193.18c-5.42,26.83,31.37,56.91,82.17,67.18,50.8,10.27,96.38-3.17,101.81-30,3.39-16.77-11.06-28.11-33.77-41.79-13.62-8.21-27.32-31.61-46.37-35.46s-40.06,12.42-55.6,14.54c-26.7,3.65-44.82,8.56-48.25,25.52Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m207.92,214.46c8.78-2.06,23.29-4.18,40.85-.77,19.01,3.69,33,12.2,40.83,17.84"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFailure);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/failure.svg";